import React from "react";

import { StyledSVG } from "../StyledIcon";

export const TrendingIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_2142_41139)">
        <path
          d="M0.75 13.1489L5.83872 8.06021C6.61977 7.27916 7.8861 7.27916 8.66714 8.06021L8.96313 8.3562C9.74418 9.13725 11.0105 9.13725 11.7916 8.3562L15.5233 4.6245"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M11.5105 3.91187H16.1848V8.58618"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      </g>
      <defs>
        <clipPath id="clip0_2142_41139">
          <rect width="18" height="18" fill="white" vectorEffect="non-scaling-stroke" />
        </clipPath>
      </defs>
    </StyledSVG>
  );
};
